import { CelebrityDashboard } from "@/features/celebrities/celebrity-dashboard";
import { Breadcrumb } from "@/app/layout/breadcrumb";

export function CelebritiesPage() {
  return (
    <div>
      <Breadcrumb
        items={[{ label: "App" }, { label: "Main" }, { label: "Celebrities", active: true }]}
      />

      <h1 className="page-title-lb">
        Celebrities <small>Manage opponents, pacing and voice clips</small>
      </h1>

      <CelebrityDashboard />
    </div>
  );
}
